export const SUPER_ADMIN = 'SUPER_ADMIN';
export const BRAND_ADMIN = 'BRAND_ADMIN';
export const ADMIN = 'ADMIN';
export const OWNER = 'OWNER';
export const MANAGER = 'MANAGER';
